import { Modal } from 'antd';

import { toastSuccess, toastError } from '../utils/toastr';
import requestAPI from './requestAPI';

const { confirm } = Modal;

export const showDeleteFileModal = (
	selectedElementsName,
	setChangedBrowserDataWhenDelete,
	selectElements,
	site_id,
	directory
) => {
	const sendData = async () => {
		const dirs = [];
		const files = [];
		await selectedElementsName.selectedElements.forEach((elem) => {
			if (elem.isFolder === true) {
				dirs.push(elem.name);
			} else {
				files.push(elem.name);
			}
		});

		if (dirs.length) {
			const dirsParams = {
				routeParams: {
					route: 'dir'
				},
				method: 'DELETE',
				data: {
					site_id,
					directory,
					name: dirs
				}
			};

			await requestAPI(dirsParams)
				.then((response) => {
					if (response.data.error.length) {
						toastError(response.data.error);
					} else {
						toastSuccess('Directory successful removal!', 'OK');
					}
				})
				.catch((error) => {
					toastError(error, 'Error');
				});
		}

		if (files.length) {
			const filesParams = {
				routeParams: {
					route: 'file'
				},
				method: 'DELETE',
				data: {
					site_id,
					directory,
					filename: files
				}
			};

			await requestAPI(filesParams)
				.then((response) => {
					if (response.data.error.length) {
						toastError(response.data.error);
					} else {
						toastSuccess('Files successful removal!', 'OK');
					}
				})
				.catch((error) => {
					toastError(error, 'Error');
				});
		}
		const allRemovedFiles = files.concat(dirs);
		setChangedBrowserDataWhenDelete(allRemovedFiles);
		selectElements(
			selectedElementsName.selectedElements.filter((elem) => {
				return allRemovedFiles.indexOf(elem.name) < 0;
			})
		);
	};

	confirm({
		title: 'Are you sure you want to delete this file?',
		okText: 'Yes',
		okType: 'danger',
		cancelText: 'No',
		onOk() {
			sendData();
		}
	});
};
